import React from 'react';
import { makeStyles, Theme, Typography } from '@material-ui/core';
//import Swoosh from './swoosh';
import VideoLogo from './VideoLogo';
import CafeSocialLogo from './CafeSocialLogo';
import { useAppState } from '../../state';
import UserMenu from './UserMenu/UserMenu';
import { useLocation } from 'react-router-dom';

import backgroundImage from '../../images/constellation_bw.jpg';

const useStyles = makeStyles((theme: Theme) => ({
  background: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //background: 'rgb(40, 42, 43)',
    width: '100%',
    height: '100%',
    background: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    opacity: '0.8',
  },
  container: {
    position: 'relative',
    flex: '1',
  },
  innerContainer: {
    display: 'flex',
    width: '888px',
    height: '479px',
    borderRadius: '10px',
    boxShadow: '0px 2px 4px 0px rgba(40, 42, 43, 0.3)',
    overflow: 'hidden',
    position: 'relative',
    margin: 'auto',
    border: '1px solid #ffffff',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      height: 'auto',
      width: 'calc(100% - 40px)',
      margin: 'auto',
      maxWidth: '400px',
    },
  },
  swooshContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //backgroundImage: Swoosh,
    //backgroundSize: 'cover',
    background: 'linear-gradient(45deg, #051dff 0, #b500ff 100%)',
    width: '296px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100px',
      //backgroundPositionY: '140px',
    },
  },
  logoContainer: {
    position: 'absolute',
    width: '210px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      width: '90%',
      textAlign: 'initial',
      '& svg': {
        height: '64px',
      },
    },
  },
  cafesocialLogo: {
    position: 'absolute',
    top: 0,
    left: 0,
    margin: '20px',
  },
  content: {
    background: 'white',
    width: '100%',
    padding: '4em',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      padding: '2em',
    },
  },
  contentScrollable: {
    overflow: 'hidden scroll',
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden',
    },
  },
  title: {
    color: 'white',
    margin: '1em 0 0',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      fontSize: '1.1rem',
    },
  },
}));

interface IntroContainerProps {
  children: React.ReactNode;
  scrollable?: boolean | false;
}

const IntroContainer = (props: IntroContainerProps) => {
  const classes = useStyles();
  const { user } = useAppState();
  const location = useLocation();

  const contentClass = props.scrollable ? `${classes.content} ${classes.contentScrollable}` : classes.content;

  return (
    <div className={classes.background}>
      <CafeSocialLogo className={classes.cafesocialLogo} />
      {user && location.pathname !== '/login' && <UserMenu />}
      <div className={classes.container}>
        <div className={classes.innerContainer}>
          <div className={classes.swooshContainer}>
            <div className={classes.logoContainer}>
              <CafeSocialLogo width="100" height="100" />
              <Typography variant="h6" className={classes.title}>
                CafeSocial.io
                <br />
                Mixer
              </Typography>
            </div>
          </div>

          <div className={contentClass}>{props.children}</div>
        </div>
      </div>
    </div>
  );
};

export default IntroContainer;
